import React from "react";
import SuperfluidWidget from "@superfluid-finance/widget";
import { createTheme } from "@mui/material";
import { common } from "@mui/material/colors";
import { icons } from "utils/constants";
import Roundedloader from "components/layouts/Roundedloader";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { addSubscription, getMySubscription } from "store/globalSlice";
import { useDispatch, useSelector } from "react-redux";

const theme = createTheme({
  palette: {
    primary: {
      main: "#5EB44B",
      contrastText: common.white,
    },
  },
});

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      paper: "#070924f3",
      default: "#070924f3",
    },
  },
});

const CustomSuperfluidWidget = ({
  productDetails,
  paymentDetails,
  eventListeners,
  loading,
  sub_tier_id,
  subscriptionType,
  subscriptionStatus,
  setIsOpenPopupSuper,
  discountPercentage,
  isDiv1Enabled,
}) => {
  const dispatch = useDispatch();
  const reduxData = useSelector((state) => state.global);
  const { globalChainID, isDarkMode } = reduxData || {};

  const handleAddSubscription = async (id) => {
    const res = await dispatch(
      addSubscription({ sub_tier_id: id, chain_id: globalChainID })
    );
    await dispatch(getMySubscription());
    return res;
  };

  return (
    <>
      <ConnectButton.Custom>
        {({ openConnectModal, connectModalOpen }) => {
          const walletManager = {
            open: async () => openConnectModal(),
            isOpen: connectModalOpen,
          };
          return (
            <>
              <SuperfluidWidget
                type="dialog"
                productDetails={productDetails}
                paymentDetails={paymentDetails}
                walletManager={walletManager}
                eventListeners={eventListeners}
                theme={isDarkMode ? darkTheme : theme}
              >
                {({ openModal }) => {
                  return (
                    <>
                      <div className="">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="cmt-10">
                            <div className="d-flex">
                              <span className="w-30 h-30">
                                <img
                                  src={icons.unodeChain}
                                  alt="left-icon"
                                  className="fit-image"
                                />
                              </span>
                              <div
                                className={`text-20-600 ${
                                  isDarkMode ? "color-ffff" : "color-2749"
                                } mb-2 cps-10`}
                              >
                                Pay with FUND
                              </div>
                            </div>
                            <ul
                              className={`text-16-400 ${
                                isDarkMode ? "color-c9c9" : "color-7e91"
                              }`}
                            >
                              <li>Pay with Fund (on Ethereum or Polygon)</li>
                              {/* <li>Spend natively</li> */}
                              <li>Choose your subscription term</li>
                              <li>Modify your subscription at anytime</li>
                              <li>Secure a steady rate</li>
                              <li>Revenue Sharing (coming with UNoDE 2.0)</li>
                            </ul>
                          </div>
                          {isDiv1Enabled && (
                            <div
                              className={`button-container-superfluid cpe-14 ${
                                subscriptionType === "superfluid" ||
                                subscriptionStatus !== "active"
                                  ? ""
                                  : "Inactive"
                              } ${isDiv1Enabled ? "fade-in-animation" : ""}`}
                            >
                              <div
                                className={`btn-block fa-center pointer`}
                                onClick={
                                  subscriptionStatus === "active"
                                    ? async () => {
                                        const res = await handleAddSubscription(
                                          sub_tier_id
                                        );
                                        if (res?.status === 409) {
                                          setIsOpenPopupSuper(true);
                                        }
                                      }
                                    : async () => {
                                        const res = await handleAddSubscription(
                                          sub_tier_id
                                        );
                                        if (res?.status === 201) {
                                          openModal();
                                        }
                                      }
                                }
                              >
                                <span className="d-flex align-items-center justify-content-center gap-2">
                                  {/* {icons.superfluid && (
                                      <span className="h-20 d-flex">
                                        <img src={icons.superfluid} alt="left-icon" className="fit-image" />
                                      </span>
                                    )}
                                    <span>SuperFluid</span> */}
                                  <span className="text-18-500 color-ffff">
                                    Pay with FUND
                                  </span>
                                  {loading && (
                                    <span>
                                      <Roundedloader
                                        type={isDarkMode ? "L" : "D"}
                                      />
                                    </span>
                                  )}
                                </span>
                              </div>
                              {discountPercentage ? (
                                <span className="text-16-400 align-items-center d-flex color-ad2a cms-20">
                                  -{discountPercentage}% Off
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  );
                }}
              </SuperfluidWidget>
            </>
          );
        }}
      </ConnectButton.Custom>
    </>
  );
};

export default CustomSuperfluidWidget;
